import React from 'react';

// From https://github.com/jupyter/design/blob/master/logos/Favicon/favicon.svg
export const JupyterNotebooks = props => (
  <svg
    width="24"
    height="24"
    stroke="currentColor"
    viewBox="0 0 24 24"
    fill="none"
    strokeLinejoin="round"
    strokeWidth="2"
    {...props}
  >
    <path d="m12,18.97c-4.05,0-7.6-1.45-9.44-3.6.71,1.93,2,3.59,3.69,4.77,1.69,1.18,3.7,1.81,5.75,1.81s4.07-.63,5.75-1.81c1.69-1.18,2.98-2.84,3.69-4.77-1.83,2.14-5.38,3.6-9.44,3.6Z" />
    <path d="m12,5.03c4.05,0,7.6,1.45,9.44,3.6-.71-1.93-2-3.59-3.69-4.77-1.69-1.18-3.7-1.81-5.75-1.81s-4.07.63-5.75,1.81c-1.69,1.18-2.98,2.84-3.69,4.77,1.84-2.15,5.38-3.6,9.44-3.6Z" />
  </svg>
);
